import styled from 'styled-components'
import { rem } from 'polished'

import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import LayoutContainer from 'components/Common/LayoutContainer'

interface Props {
  title?: string
  description?: string
  titleTag?: any
}

const Description = styled(BodyText)`
  margin-bottom: ${rem(35)};
`

function OfferListHeading(props: Props) {
  const { title, description, titleTag = 'h1' } = props
  if (!title && !description) {
    return null
  }
  return (
    <LayoutContainer size="md">
      <Heading variant="heading2" align="center" as={titleTag}>{title}</Heading>
      {description && <Description variant="large" align="center" forwardedAs="h2">
        {description}
      </Description>}
    </LayoutContainer>
  )
}

export default OfferListHeading
